// Profile colors for calendar blocks. Each selected calendar gets the next
// slot. Appointment type does not pick a color.
//
// Full blocks use the 100 fill with CALENDAR_BLOCK_TEXT. Outline blocks (an
// unanswered or declined Google invite) use a white fill, the 800 border, and
// the 900 text. Values are the Tailwind v4 palette from the calendar color
// library: blue, red, green, purple, orange, teal, pink, yellow, grey.

export interface CalendarColor {
  fill: string
  border: string
  text: string
}

export const CALENDAR_BLOCK_TEXT = '#0c0a09'

export const CALENDAR_COLORS: readonly CalendarColor[] = [
  { fill: '#dbeafe', border: '#193cb8', text: '#1c398e' },
  { fill: '#ffe2e2', border: '#9f0712', text: '#82181a' },
  { fill: '#dcfce7', border: '#016630', text: '#0d542b' },
  { fill: '#f3e8ff', border: '#6e11b0', text: '#59168b' },
  { fill: '#ffedd4', border: '#9f2d00', text: '#7e2a0c' },
  { fill: '#cbfbf1', border: '#005f5a', text: '#0b4f4a' },
  { fill: '#fce7f3', border: '#a3004c', text: '#861043' },
  { fill: '#fef9c2', border: '#894b00', text: '#733e0a' },
  { fill: '#f5f5f4', border: '#292524', text: '#1c1917' },
]

export const UNASSIGNED_CALENDAR_COLOR: CalendarColor =
  CALENDAR_COLORS[CALENDAR_COLORS.length - 1]
